import initSpangleColorReference from "components/jiffy/spangle-color-reference/spangle-color-reference";

document.addEventListener("DOMContentLoaded", initSpangleColorReference);
